<div class="filters row">
    <div class="row">
        <div class="r-form-group">
            <label class="title">{{'LIDS.START_DATE' |translate}}</label>
            <p-calendar dateFormat="dd/mm/yy" [showButtonBar]="true" inputId="basic" [(ngModel)]="startDate"
                [clearButtonStyleClass]="'clear-button'" (onClearClick)="filterCreatedDate()"
                (onSelect)="filterCreatedDate()">
            </p-calendar>
        </div>
        <div class="r-form-group">
            <label class="title">{{'LIDS.END_DATE' |translate}}</label>
            <p-calendar dateFormat="dd/mm/yy" [showButtonBar]="true" inputId="basic" [(ngModel)]="endDate"
                [clearButtonStyleClass]="'clear-button'" (onClearClick)="filterCreatedDate()"
                (onSelect)="filterCreatedDate()" (onClickOutside)="filterCreatedDate()"></p-calendar>
        </div>
        <div class="r-form-group">
            <label class="title">{{'BUSINESS_COUPON.STATUS' | translate}}</label>
            <p-dropdown [options]="translatedStatusOptions" [(ngModel)]="selectedStatus" optionLabel="label"  optionValue="value"
                placeholder="{{'BUSINESS_COUPON.STATUS' | translate}}" [showClear]="true" (onClear)="filterStatus()"
                (onChange)="filterStatus()">
            </p-dropdown>
        </div>

    </div>

    <div class="r-form-group totalRecords">{{totalRecords}} {{'BUSINESS_COUPON.COUNT_BUSINESS_COUPONS'|translate}}</div>
    <app-atn-export-excel [request]="request"  [fileName]="'BusinessCoupon'"></app-atn-export-excel>
</div>

<div class="table">
    <app-readonly-table #dt [columns]="columns" [selectionMode]="null" [itemsSource$]="businessCoupons$"
        [isFilterable]="false"  [paginator]="true" (onLoadData)="onLoadData($event)"
        [isLoadLazy]="true" [totalRecords]="totalRecords" [rowsPerPageOptions]="null">
    </app-readonly-table>
</div>
